export default "__VITE_ASSET__bb2b7245__"